import { render } from "./LineBg.vue?vue&type=template&id=745b9100"
import script from "./LineBg.vue?vue&type=script&lang=js"
export * from "./LineBg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__